import {put} from 'redux-saga/effects'
import {ADD_TOAST} from '../constants/actiontypes'
import 'whatwg-fetch'

export function *login_error(action) {
    if(action.error instanceof Error)
        yield put({type: ADD_TOAST, toast: {text: action.error.message}});
}